// extracted by mini-css-extract-plugin
export default {"anErrorPlaceholder":"ErrorPlaceholder_anErrorPlaceholder__y0ZYL","absolutePosition":"ErrorPlaceholder_absolutePosition__LHu7w"};